import { useQuery } from '@tanstack/react-query';
import { getPublicProviderProfiles, getProviderPublicProfile } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';
import { providerQueryKeys } from './provider';

export const useProviderPublicMatchingProfile = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryFn: () => getProviderPublicProfile(providerId),
    queryKey: [ 'provider-public-matching-profile', providerId ],
    select: r => r.data,
    staleTime: Infinity,
    ...opts,
  });
};

export const useProviderPublicProfiles = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryFn: async () => getPublicProviderProfiles(providerId),
    queryKey: providerQueryKeys.publicProfiles(providerId),
    select: p => p.data,
    enabled: !!providerId,
    ...opts,
  });
};
